
import PropTypes from "prop-types";
import { lazy } from "react";
import useAppModernisation from "../hooks/useAppModernisation";

const NavBarClassic = lazy(() => import("./navBarClassic"));
const NavBarModern = lazy(() => import("./navBar/NavBarModern"));

const NavBar = (props) => {
  const { isEnhancedSearchEnabled } = useAppModernisation();
  return isEnhancedSearchEnabled ? (
    <NavBarModern {...props }></NavBarModern>
  ) : (
    <NavBarClassic {...props}></NavBarClassic>
  );
};

NavBar.propTypes = {
  searchIndex: PropTypes.number,
  setSearchTerm: PropTypes.func,
  push: PropTypes.func.isRequired,
  setWithinSearchVal: PropTypes.func,
};

export default NavBar;
